import Q from 'q';
import _ from 'underscore';

export default {
  components: {},
  data() {
    return {}
  },
  methods: {},
  created() {
    // const __this = this;
  },
  activated() {
    const __this = this;

    __this.form.userName = ``;
    __this.form.userPassword = ``;
  },
  deactivated() {
    // const __this = this;
  },
}
